// extracted by mini-css-extract-plugin
export default {"logout-button":"user-area_logout-button__FrX8g"};